import { observer } from "mobx-react";
import * as React from "react";
import { Button, Classes, Dialog, FileInput, FormGroup } from "@blueprintjs/core";
import { UtilitarioStore } from "../../stores/utilitarios/UtilitarioStore";
import { observable } from "mobx";
import LoadingModal from "../loading/LoadingModal";

interface Props {
  onClose: () => void;
}

interface State {
  isOpen: boolean
}

@observer
export default class EqualizaNcm extends React.Component<Props, State> {

  constructor(props) {
    super(props)

    this.state = {
      isOpen: false
    }
  }

  async componentDidMount() {

    this.setState({ isOpen: true })

  }

  handleFileInputChange = async (event) => {

    const file = event.target.files[0];

    UtilitarioStore.obs.file_name = file.name

    var data = new FormData();
    data.append("file", file);

    this.setState({ isOpen: false })

    UtilitarioStore.obs.loading_equaliza_ncm = true

    await UtilitarioStore.handleEqualizaNcm(data)

    this.props.onClose()

    UtilitarioStore.obs.file_name = "Selecione um arquivo CSV"

  };

  render() {

    return (
      <>

        <Dialog isOpen={this.state.isOpen} title={"Equalizar NCMs"} onClose={(e) => this.props.onClose()}>
          <div className={Classes.DIALOG_BODY}>

            <br />

            <FormGroup label="">
              <FileInput text={UtilitarioStore.obs.file_name} className="bp3-fill bp3-file-input-has-selection input-file-certificado" onInputChange={this.handleFileInputChange} />
            </FormGroup>
          </div>

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Fechar" intent="primary" onClick={() => this.props.onClose()} />
            </div>
          </div>

        </Dialog>

        <LoadingModal open={UtilitarioStore.obs.loading_equaliza_ncm} onClose={() => UtilitarioStore.obs.loading_equaliza_ncm = false} title={"Equalizando NCMs"} />

      </>

    );

  }

}
